@if (error()) {
  <p class="cl-p-regular cl-color-brick">{{ error() }}</p>
}

<p class="cl-p-regular">
  @if (places().length === 0) {
    Portal root
  } @else {
    <a href="" (click)="$event.preventDefault(); goTo(0)">Portal root</a>
    @for (place of places(); track $index; let last = $last; let i = $index) {
      /
      @if (last) {
        {{ place.name }}
      } @else {
        <a href="" (click)="$event.preventDefault(); goTo(i + 1)">{{ place.name }}</a>
      }
    }
    · <a href="" (click)="$event.preventDefault(); up()">up one folder</a>
  }
</p>

<div class="cl-table-scroll">
  <table class="cl-table-data">
    <thead>
      <tr>
        <th class="cl-table-head">Name</th>
        <th class="cl-table-head cl-th-currency">Size</th>
        <th class="cl-table-head">Modified</th>
        @if (actionTemplate) {
          <th class="cl-table-head cl-th-links">{{ actionHeader() }}</th>
        }
      </tr>
    </thead>
    <tbody>
      @if (loading()) {
        <tr class="cl-tr-no-data"><td colspan="100"><div class="cl-spinner">Loading ...<i class="fas fa-spinner fa-spin"></i></div></td></tr>
      } @else {
        @for (entry of entries(); track entry.folderId + entry.path) {
          <tr>
            <td>
              @if (entry.isDirectory) {
                <a href="" (click)="$event.preventDefault(); open(entry)">{{ entry.name }}/</a>
              } @else {
                {{ entry.name }}
              }
            </td>
            <td class="cl-td-currency">{{ entry.isDirectory ? '—' : (entry.size | fileSize) }}</td>
            <td class="cl-td-time"><app-date [value]="entry.modifiedAt" empty="—" /></td>
            @if (actionTemplate) {
              <td class="cl-td-links" width="1%">
                @if (!entry.isDirectory) {
                  <ng-container
                    [ngTemplateOutlet]="actionTemplate"
                    [ngTemplateOutletContext]="{$implicit: entry}"></ng-container>
                }
              </td>
            }
          </tr>
        }
        @if (noSession() && entries().length === 0) {
          <tr class="cl-tr-no-data"><td colspan="100">Log in to this portal to browse its files.</td></tr>
        } @else if (entries().length === 0) {
          <tr class="cl-tr-no-data"><td colspan="100">{{ places().length === 0 ? 'This portal exposes no files.' : 'This folder is empty.' }}</td></tr>
        }
      }
    </tbody>
  </table>
</div>
